"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/MFA/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _components = require('web/screens/Signup/components');
var _CodeForm = require('web/screens/Login/MFA/CodeForm'); var _CodeForm2 = _interopRequireDefault(_CodeForm);
var _PhoneForm = require('web/screens/Login/MFA/PhoneForm'); var _PhoneForm2 = _interopRequireDefault(_PhoneForm);

const ORG_REQUIRES_SMS = 'Your organization requires SMS verification before you start using BloomText.'
const codeIntro = (phone) => _react2.default.createElement(_react2.default.Fragment, null, "Enter the 6-digit code we texted to "       ,  phone , ".")






const MFASection = ({ challenge, onVerified }) => {
  const [maskedPhone, setMaskedPhone] = _react.useState.call(void 0, challenge.MaskedPhone)
  const [isEnrollmentRequired, setIsEnrollmentRequired] = _react.useState.call(void 0, challenge.EnrollmentRequired)

  const sendPhoneCode = (phone) =>
    _client2.default.sendLoginMFAPhoneCode(challenge.ChallengeKey, phone)
      .then(r => {
        setMaskedPhone(r.MaskedPhone)
        setIsEnrollmentRequired(false)
      })

  const verify = (code) =>
    _client2.default.verifyLoginMFA(challenge.ChallengeKey, code, false)
      .then(onVerified)

  const resend = () =>
    _client2.default.resendLoginMFACode(challenge.ChallengeKey)
      .then(r => { setMaskedPhone(r.MaskedPhone) })

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_components.SignupStepHeader, { title: "Verify your phone"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} )
      ,  isEnrollmentRequired
        ? _react2.default.createElement(_PhoneForm2.default, { onSubmit: sendPhoneCode, phonePolicy: challenge.PhonePolicy, intro: ORG_REQUIRES_SMS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}} )
        : _react2.default.createElement(_CodeForm2.default, { maskedPhone: maskedPhone, onSubmit: verify, onResend: resend, intro: codeIntro, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}} )
      
    )
  )
}

exports. default = MFASection
